import React, { Component, Fragment } from "react";
import {
  Button,
  Row,
  Col,
  Steps,
  Icon,
  notification,
  Radio,
  Modal,
  Drawer,
  Spin,
  Table,
  Select
}
from "antd";
import moment from 'moment'
import { Storage } from 'aws-amplify';
// import { ListAucAdminOrganizationsUsers } from 'queries';
import { Mutation, Query } from 'react-apollo'
import { updateProceeding, reportProceeding, reportMail } from 'mutations'
import { getProceeding, getChain, listFieldsInfos } from 'queries'
import gql from "graphql-tag";

// import StepContainer from 'steps/StepContainer'
const Step = Steps.Step;
const RadioGroup = Radio.Group
const { Option, OptGroup } = Select;
const stepLabels = {
  "1": "Zamawiajacy",
  "2": "Przedmiot zamówienia",
  "3": "Przygotowanie postępowania",
  "4": "Osoby cz. A",
  "5": "Osoby cz. B",
  "6": "Osoby cz. C",
  "7": "Ogłoszenie",
  "8": "SIWZ i wymagania",
  "9": "Miejsce i termin",
  "21": "Otwarcie ofert",
  "22": "Zestawienie ofert",
  "23": "Wezwania",
  "24": "Wykluczenia",
  "25": "Odrzucenia",
  "26": "Wybór oferty",
  "27": "Zatwierdzenie wyniku",
  "28": "Zawiadomienie",
  "51": "Udzielenie zamówienia",
  "52": "Ochrona prawna",
  "53": "Nowe/powtórzone czynności",
  "54": "Zamówienia",
  "55": "Protokół",
  "56": "Załączniki"
}


// const renderTabBar = (props, DefaultTabBar) => (
//   <DefaultTabBar {...props} style={{ zIndex: 1, background: "#fff" }} />
// );

class ComponentContainer extends Component {
  state = {
    toUpdate: this.props.unsavedChanges
  }

  componentDidMount() {
    if (this.props.current === 21 || this.props.current === 51)
      this.props.UpdateProceeding({
        refetchQueries: [{
          query: gql(getChain),
          variables: { id: this.props.proceeding.id }
        }],
        variables: {
          input: { step: this.props.current, id: this.props.proceeding.id }
        }
      })
  }

  onSubmit(e, form, UpdateProceeding, reload = false) {
    e.preventDefault();
    this.setState({ saving: true });

    const _this2 = this;

    // console.log('Inn', UpdateProceeding)

    form.validateFields((err, values) => {

      Object.keys(values).forEach(function(key, index) {

        if (values[key] === '') values[key] = null
      });

      if (this.props.proceeding.step > values.step && values.step !== 28 && values.step !== 9)
        values.step = this.props.proceeding.step

      console.log(this.props.proceeding.step, values.step)
      if (this.props.proceeding.step < values.step) {

        if (
          (this.props.proceeding.step < 10 && values.step > 20) ||
          (this.props.proceeding.step < 30 && values.step > 50)
        ) {

          if (!((this.props.proceeding.step === 9 && values.step === 21) || (this.props.proceeding.step === 28 && values.step === 51))) {
            notification['error']({
              duration: 3,
              message: 'Poprzedni etap nie został zakończony. ',
              description: 'Wciśnij Wróć i zakończ poprzednie etapy!',
            });
            this.setState({ saving: false });
            return false
          }



        }




      }

      if (!err) {
        // let date = new Date()
        UpdateProceeding({
            refetchQueries: [{
              query: gql(getChain),
              variables: { id: this.props.proceeding.id }
            }],
            variables: {
              input: { ...values, id: this.props.proceeding.id }
            }
          })
          .then(({ data }) => {
            this.setState({
              saving: false
            });
            if (!_this2._unmounted) {
              notification['success']({
                duration: 2,
                message: 'Zmiane zostały zapisane',
                description: 'Ostatni zapis: ' + moment().format('YYYY-MM-DD hh:mm'),
              });
              this.setState({
                toUpdate: false
              });
            }
          })
          .catch(error => {
            console.log(error);
            this.setState({ saving: false });
          });


      }
      else {
        this.setState({ saving: false });
      }

      if (reload) {
        this.props.reload(values.step)
      }

    });

  }

  setToUpdate = (num) => {
    if (num === null || num !== this.props.proceeding.step)
      this.setState({ toUpdate: true })
    else
      this.setState({ toUpdate: false })
  }

  render() {
    const { Component, proceeding, UpdateProceeding, current } = this.props

    const real = current % 10


    return (
      <Fragment>
        <h3 style={{ marginTop: "-25px" }}>{real}. { stepLabels[""+current] }</h3>
        <Component p={proceeding} 
          saving={this.state.saving} 
          setToUpdate={this.setToUpdate} 
          toUpdate={ this.state.toUpdate } 
          onSubmit={(e, form, reload)=>this.onSubmit(e, form, UpdateProceeding, reload)}  
        />
      </Fragment>
    )
  }
}

class FieldsInfoList extends Component {
  // componentDidMount() {
  //     this.props.subscribeToNew();
  //     if (!this.props.selected && this.props.mails.items) {
  //         this.props.onSelect(this.props.mails.items[0])
  //     }
  // }
  // columns = [{
  //     title: 'Temat',
  //     dataIndex: 'subject',
  // }, {
  //     title: 'Od',
  //     dataIndex: 'from_name',
  // }];

  render() {
    const { items, refetch } = this.props
    const trans = { field21: "Etap 1, Krok 1, Pole 1", field22: "Etap 1, Krok 2, Pole 1", field22Reason: "Etap 1, Krok 2, Pole 2", field22Parts: "Etap 1, Krok 2, Pole 3", field23: "Etap 1, Krok 2, Pole 4", field23Int: "Etap 1, Krok 2, Pole 5", field23Int2: "Etap 1, Krok 2, Pole 6", field24Type1PLN: "Etap 1, Krok 2, Pole 7", field24Type2PLN: "Etap 1, Krok 2, Pole 8", field24Type3PLN: "Etap 1, Krok 2, Pole 9", field24Type4PLN: "Etap 1, Krok 2, Pole 10", field24Type51PLN: "Etap 1, Krok 2, Pole 11", field24Type52PLN: "Etap 1, Krok 2, Pole 12", field24Type1EUR: "Etap 1, Krok 2, Pole 13", field24Type2EUR: "Etap 1, Krok 2, Pole 14", field24Type3EUR: "Etap 1, Krok 2, Pole 15", field24Type4EUR: "Etap 1, Krok 2, Pole 16", field24Type51EUR: "Etap 1, Krok 2, Pole 17", field24Type52EUR: "Etap 1, Krok 2, Pole 18", field24Type1: "Etap 1, Krok 2, Pole 19", field24Type2: "Etap 1, Krok 2, Pole 20", field24Type3: "Etap 1, Krok 2, Pole 21", field24Type4: "Etap 1, Krok 2, Pole 22", field24Type5: "Etap 1, Krok 2, Pole 23", field25Date: "Etap 1, Krok 2, Pole 24", field25BasedOn: "Etap 1, Krok 2, Pole 25", field26: "Etap 1, Krok 2, Pole 26", field26Proc: "Etap 1, Krok 2, Pole 27", field26Prog: "Etap 1, Krok 2, Pole 28", field31: "Etap 1, Krok 3, Pole 29", field31Companies: "Etap 1, Krok 3, Pole 30", field31Influence: "Etap 1, Krok 3, Pole 31", field32: "Etap 1, Krok 3, Pole 32", field32Action: "Etap 1, Krok 3, Pole 33", field41: "Etap 1, Krok 4, Pole 34", field41Assistant: "Etap 1, Krok 4, Pole 35", field41AssistantName: "Etap 1, Krok 4, Pole 36", field41AssistantTasks: "Etap 1, Krok 4, Pole 37", field42: "Etap 1, Krok 4, Pole 38", field42Data: "Etap 1, Krok 4, Pole 39", field42BasedOn: "Etap 1, Krok 4, Pole 40", field42Members: "Etap 1, Krok 4, Pole 41", field42nCMembers: "Etap 1, Krok 4, Pole 42", field43: "Etap 1, Krok 4, Pole 43", field43Data: "Etap 1, Krok 4, Pole 44", field43Members: "Etap 1, Krok 4, Pole 45", field43nCMembers: "Etap 1, Krok 4, Pole 46", field44: "Etap 1, Krok 4, Pole 47", field44Members: "Etap 1, Krok 4, Pole 48", field45: "Etap 1, Krok 4, Pole 49", field45Members: "Etap 1, Krok 4, Pole 50", field4B1Desc: "Etap 1, Krok 4, Pole 51", field4B2Value: "Etap 1, Krok 4, Pole 52", field4B3DescJoin: "Etap 1, Krok 4, Pole 53", field4B4Criteria: "Etap 1, Krok 4, Pole 54", field4B5Other: "Etap 1, Krok 4, Pole 55", field4C: "Etap 1, Krok 4, Pole 56", field4D: "Etap 1, Krok 4, Pole 57", field4DDesc: "Etap 1, Krok 4, Pole 58", field5: "Etap 1, Krok 5, Pole 59", field51: "Etap 1, Krok 5, Pole 60", field51In: "Etap 1, Krok 5, Pole 61", field51Date: "Etap 1, Krok 5, Pole 62", field52: "Etap 1, Krok 5, Pole 63", field52Info: "Etap 1, Krok 5, Pole 64", field52Date: "Etap 1, Krok 5, Pole 65", field61: "Etap 1, Krok 6, Pole 66", field61Date: "Etap 1, Krok 6, Pole 67", field61Date2: "Etap 1, Krok 6, Pole 68", field61No: "Etap 1, Krok 6, Pole 69", field62: "Etap 1, Krok 6, Pole 70", field63Url: "Etap 1, Krok 6, Pole 71", field63From: "Etap 1, Krok 6, Pole 72", field63To: "Etap 1, Krok 6, Pole 73", field64: "Etap 1, Krok 6, Pole 74", field65: "Etap 1, Krok 6, Pole 75", field65Desc: "Etap 1, Krok 6, Pole 76", field66: "Etap 1, Krok 7, Pole 77", field66Comp: "Etap 1, Krok 7, Pole 78", field67: "Etap 1, Krok 7, Pole 79", field67Date: "Etap 1, Krok 7, Pole 80", field67No: "Etap 1, Krok 7, Pole 81", field67NoDate: "Etap 1, Krok 7, Pole 82", field68: "Etap 1, Krok 7, Pole 83", field7: "Etap 1, Krok 8, Pole 84", field7Url: "Etap 1, Krok 8, Pole 85", field7From: "Etap 1, Krok 8, Pole 86", field7To: "Etap 1, Krok 8, Pole 87", field71: "Etap 1, Krok 8, Pole 88", field71Date: "Etap 1, Krok 8, Pole 89", field71Desc: "Etap 1, Krok 8, Pole 90", field8: "Etap 1, Krok 8, Pole 91", field8Desc: "Etap 1, Krok 8, Pole 92", field9: "Etap 1, Krok 8, Pole 93", field101: "Etap 1, Krok 9, Pole 94", field101Reason: "Etap 1, Krok 9, Pole 95", field102: "Etap 1, Krok 9, Pole 96", field103: "Etap 1, Krok 9, Pole 97", field103Time: "Etap 1, Krok 9, Pole 98", field103Expand: "Etap 1, Krok 9, Pole 99", field103ExpandDate: "Etap 1, Krok 9, Pole 100", field104: "Etap 1, Krok 9, Pole 101", field111Date: "Etap 2, Krok 1, Pole 102", field111In: "Etap 2, Krok 1, Pole 103", field111Addr: "Etap 2, Krok 1, Pole 104", field112Ammount: "Etap 2, Krok 1, Pole 105", field112Parts: "Etap 2, Krok 1, Pole 106", field113: "Etap 2, Krok 1, Pole 107", field121: "Etap 2, Krok 2, Pole 108", field121Variants: "Etap 2, Krok 2, Pole 109", field122: "Etap 2, Krok 2, Pole 110", field131: "Etap 2, Krok 3, Pole 111", field131Names: "Etap 2, Krok 3, Pole 112", field132: "Etap 2, Krok 3, Pole 113", field132Names: "Etap 2, Krok 3, Pole 114", field141: "Etap 2, Krok 4, Pole 115", field142: "Etap 2, Krok 4, Pole 116", field151: "Etap 2, Krok 4, Pole 117", field151NamesReason: "Etap 2, Krok 4, Pole 118", field152: "Etap 2, Krok 4, Pole 119", field152Names: "Etap 2, Krok 4, Pole 120", field153: "Etap 2, Krok 4, Pole 121", field153Names: "Etap 2, Krok 4, Pole 122", field154: "Etap 2, Krok 4, Pole 123", field161: "Etap 2, Krok 3, Pole 124", field162: "Etap 2, Krok 3, Pole 125", field171: "Etap 2, Krok 5, Pole 126", field171Names: "Etap 2, Krok 5, Pole 127", field181: "Etap 2, Krok 6, Pole 128", field181Net: "Etap 2, Krok 6, Pole 129", field181Desc: "Etap 2, Krok 6, Pole 130", field182: "Etap 2, Krok 6, Pole 131", field1821: "Etap 2, Krok 6, Pole 132", field183: "Etap 2, Krok 6, Pole 133", field184: "Etap 2, Krok 6, Pole 134", field190: "Etap 2, Krok 6, Pole 135", field201: "Etap 2, Krok 7, Pole 136", field201Date: "Etap 2, Krok 7, Pole 137", field201People: "Etap 2, Krok 7, Pole 138", field202: "Etap 2, Krok 7, Pole 139", field202Date: "Etap 2, Krok 7, Pole 140", field210: "Etap 2, Krok 8, Pole 141", field21Date: "Etap 2, Krok 8, Pole 142", field21Form: "Etap 2, Krok 8, Pole 143", field220: "Etap 3, Krok 1, Pole 144", field2201: "Etap 3, Krok 1, Pole 145", field231: "Etap 3, Krok 2, Pole 146", field231Name: "Etap 3, Krok 2, Pole 147", field231Info: "Etap 3, Krok 2, Pole 148", field2311: "Etap 3, Krok 2, Pole 149", field2311Name: "Etap 3, Krok 2, Pole 150", field2311Info: "Etap 3, Krok 2, Pole 151", field2311Date: "Etap 3, Krok 2, Pole 152", field232: "Etap 3, Krok 2, Pole 153", field233: "Etap 3, Krok 2, Pole 154", fiedl233Desc: "Etap 3, Krok 2, Pole 155", field234: "Etap 3, Krok 2, Pole 156", field240: "Etap 3, Krok 3, Pole 157", field24Names: "Etap 3, Krok 3, Pole 158", field2510: "Etap 3, Krok 3, Pole 159", field251Date: "Etap 3, Krok 3, Pole 160", field251Names: "Etap 3, Krok 3, Pole 161", field2520: "Etap 3, Krok 3, Pole 162", field252Date: "Etap 3, Krok 3, Pole 163", field261Date: "Etap 3, Krok 4, Pole 164", field261With: "Etap 3, Krok 4, Pole 165", field261Value: "Etap 3, Krok 4, Pole 166", field261Subject: "Etap 3, Krok 4, Pole 167", field262: "Etap 3, Krok 4, Pole 168", field262Date: "Etap 3, Krok 4, Pole 169", field262No: "Etap 3, Krok 4, Pole 170", field262NoDate: "Etap 3, Krok 4, Pole 171", field260Files: "Etap 3, Krok 4, Pole 172", field270: "Etap 3, Krok 4, Pole 173", field281: "Etap 3, Krok 5, Pole 174", field281Name: "Etap 3, Krok 5, Pole 175", field281Name2: "Etap 3, Krok 5, Pole 176", field282: "Etap 3, Krok 5, Pole 177", field290: "Etap 3, Krok 5, Pole 178", field30Name: "Etap 3, Krok 5, Pole 179", field30Place: "Etap 3, Krok 5, Pole 180", field30Date: "Etap 3, Krok 5, Pole 181" }
    const columns = [{
      title: 'Pole',
      dataIndex: 'fieldName',
      key: 'name',
      render: text => trans[text],
    }, {
      title: 'Liczba interakcji',
      dataIndex: 'editCount',
      key: 'count',
    }]
    let sort = items.sort((a, b) => (parseInt(a.editCount) < parseInt(b.editCount)) ? 1 : ((parseInt(b.editCount) < parseInt(a.editCount)) ? -1 : 0));
    sort = sort.slice(0, 10);
    return (
      <Fragment>
      <Button icon='reload' onClick={()=>refetch()}> Odśwież </Button><br/><br/>
      <Table columns={columns} dataSource={sort} rowKey="fieldName"/>
      </Fragment>
    )
  }

}


export default class ProceedingForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // saving: false,
      unsavedChanges: false,
      _unmounted: false,
      current: this.props.proceeding.step,
      module: null,
      gen: false,
      proceeding: this.props.proceeding,
      visible: false,
      visibleD: false,
      ext: 'pdf',
      part: null,
      genMailTxt: 'Pobierz protokół maili'
    };
  }

  showModal = (part) => {
    this.setState({
      visible: true,
      part
    });
  }

  handleOk = (e, ReportProceeding) => {
    console.log(e);
    this.genRep(ReportProceeding)
  }
  onChange = (e) => {
    this.setState({
      ext: e.target.value,
    });
  }

  onChange2 = (e) => {
    this.setState({
      withPass: e.target.checked,
    });
  }

  passChange = (e) => {
    this.setState({
      pass: e.target.value,
    });
  }

  handleCancel = (e) => {
    console.log(e);
    this.setState({
      visible: false,
    });
  }

  reload = (current) => {
    import (`steps/Step${current}`)
    .then(module => this.setState({ module: module.default, current }))
  }

  next = () => {
    const current = this.state.current + 1;
    // this.setState({  });
    import (`steps/Step${current}`)
    .then(module => this.setState({ module: module.default, current }))
  }

  prev = () => {
    const current = this.state.current - 1;
    // this.setState({ current });
    import (`steps/Step${current}`)
    .then(module => this.setState({ module: module.default, current }))

  }
  finishPart = (part) => {
    // const { step } = this.props.proceeding
    let current = 0
    if (part === 1)
      current = 22
    if (part === 2)
      current = 51
    // this.setState({ current });
    import (`steps/Step${current}`)
    .then(module => this.setState({ module: module.default, current }))
  }

  goTo = (current) => {
    const { step } = this.props.proceeding

    if (step < current) {
      notification['error']({
        message: 'Niedozwolona operacja',
        description: 'Poprzedzające kroki nie zostały wypełnione.',
      });
      return false
    }

    // this.setState({ current });
    import (`steps/Step${current}`)
    .then(module => this.setState({ module: module.default, current }))
  }

  componentWillUnmount() {
    this._unmounted = true;
  }

  componentDidMount() {
    this.props.subscribeToNew();
    import (`steps/Step${this.state.current}`)
    .then(module => {

      this.setState({ module: module.default })


    })
  }
  genRep = (ReportProceeding) => {
    this.setState({
      gen: true
    });
    const _this = this
    const { part, ext } = this.state

    ReportProceeding({
        variables: {
          input: { id: this.props.proceeding.id, part, ext }
        }
      })
      .then(({ data }) => {
        this.setState({
          gen: false,
          visible: false,
          part: null,
          ext: 'pdf'
        });
        if (!_this._unmounted) {
          Storage.get(data.reportProceeding.url)
            .then(url => {
              _this.linkRef.href = url
              _this.linkRef.click()
            })
          notification['success']({
            duration: 2,
            message: 'Protokół został wygenerowany',
            description: 'Czas generacji: ' + moment().format('YYYY-MM-DD hh:mm'),
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ saving: false });
      });
  }

  showDrawer = () => {
    this.setState({
      visibleD: true,
    });
  };

  onClose = () => {
    this.setState({
      visibleD: false,
    });
  };

  reportMail = (ReportMail) => {
    var _this = this
    this.setState({ 'genMail': true, 'genMailTxt': 'Generowanie protokołu...' })

    ReportMail({
        variables: {
          input: { pid: "" + this.props.proceeding.id, oid: this.props.proceeding.ownerId }
        }
      })
      .then(({ data }) => {
        this.setState({ 'genMail': false, 'genMailTxt': 'Pobierz protokół maili' })

        if (!_this._unmounted) {
          Storage.get(data.reportMail.url)
            .then(url => {
              _this.linkRef.href = url
              _this.linkRef.click()
            })
          notification['success']({
            duration: 2,
            message: 'Protokół został wygenerowany',
            description: 'Czas generacji: ' + moment().format('YYYY-MM-DD hh:mm'),
          });
        }
      })
      .catch(error => {
        console.log(error);
        this.setState({ saving: false });
      });
  }

  handleShortcut = (value) => {
    const me = {
      "Zamawiajacy": 1,
      "Przedmiot zamówienia": 2,
      "Przygotowanie postępowania": 3,
      "Osoby cz. A": 4,
      "Osoby cz. B": 5,
      "Osoby cz. C": 6,
      "Ogłoszenie": 7,
      "SIWZ i wymagania": 8,
      "Miejsce i termin": 9,
      "Otwarcie ofert": 21,
      "Zestawienie ofert": 22,
      "Wezwania": 23,
      "Wykluczenia": 24,
      "Odrzucenia": 25,
      "Wybór oferty": 26,
      "Zatwierdzenie wyniku": 27,
      "Zawiadomienie": 28,
      "Udzielenie zamówienia": 51,
      "Ochrona prawna": 52,
      "Nowe/powtórzone czynności": 53,
      "Zamówienia": 54,
      "Protokół": 55,
      "Załączniki": 56
    }

    this.setState({ current: me[value] })
    this.reload(me[value])
  }
  handleShortcutBack = (value) => {
    this.setState({ current: value })
    this.reload(value)
  }

  render() {
    let { proceeding } = this.props;
    const { gen, saving, current, module: Component, } = this.state;
    const radioStyle = {
      display: 'block',
      height: '30px',
      lineHeight: '30px',
    };
    const action_buttons = (
      <div className="steps__action"  style={{ float: "right", marginRight: 30}} >
           
         { current !== 1 && current!==21 && current!==51 && (
          <Button onClick={() => this.prev()}  style={{ marginRight: 10 }} >
            <Icon type="caret-left" />
            Wstecz
          </Button>
        )}       


        { current!==9 && current!==28 && current!==56 && (
          <Button
            htmlType="submit"
            onClick={() => this.next()}
          >
            Dalej <Icon type="caret-right" />
          </Button>
        )}
        
        
        
        
      </div>
    );



    const action_buttons2 = (
      <div className="steps__action2"  style={{ padding: "20px 0px",     background: '#f5f8fe', borderBottom: '1px solid #f0f0f0', marginBottom: 50 }} >
            
         
             
          <span>
            <label> Szybki dostęp: </label>
           <Select
                placeholder="Wybierz krok"
                style={{ width: 200, marginRight: 10 }}
                onSelect={this.handleShortcut}
                showSearch={true}
              >
                <OptGroup label="Etap pierwszy">
                  <Option value="Zamawiajacy">Zamawiajacy</Option>
 <Option value="Przedmiot zamówienia">Przedmiot zamówienia</Option>
 <Option value="Przygotowanie postępowania">Przygotowanie postępowania</Option>
 <Option value="Osoby cz. A">Osoby cz. A</Option>
 <Option value="Osoby cz. B">Osoby cz. B</Option>
 <Option value="Osoby cz. C">Osoby cz. C</Option>
 <Option value="Ogłoszenie">Ogłoszenie</Option>
 <Option value="SIWZ i wymagania">SIWZ i wymagania</Option>
 <Option value="Miejsce i termin">Miejsce i termin</Option>
                </OptGroup>
                <OptGroup label="Etap drugi">
                   <Option value="Otwarcie ofert">Otwarcie ofert</Option>
 <Option value="Zestawienie ofert">Zestawienie ofert</Option>
 <Option value="Wezwania">Wezwania</Option>
 <Option value="Wykluczenia">Wykluczenia</Option>
 <Option value="Odrzucenia">Odrzucenia</Option>
 <Option value="Wybór oferty">Wybór oferty</Option>
 <Option value="Zatwierdzenie wyniku">Zatwierdzenie wyniku</Option>
 <Option value="Zawiadomienie">Zawiadomienie</Option>
                </OptGroup>
                <OptGroup label="Etap trzeci">
 <Option value="Udzielenie zamówienia">Udzielenie zamówienia</Option>
 <Option value="Ochrona prawna">Ochrona prawna</Option>
 <Option value="Nowe/powtórzone czynności">Nowe/powtórzone czynności</Option>
 <Option value="Zamówienia">Zamówienia</Option>
 <Option value="Protokół">Protokół</Option>
 <Option value="Załączniki">Załączniki</Option>
                </OptGroup>
              </Select>
          </span>    
          {current !== this.props.proceeding.step && <Button title="Wróc do aktualnego kroku" onClick={() => this.handleShortcutBack(this.props.proceeding.step)}  style={{ marginRight: 10 }} >
            <Icon type="backward"  />
              Wróć
          </Button>}

     { current!==9 && current!==28 && current!==56 && (
          <Button
            htmlType="submit"
            onClick={() => this.next()}
            title="Idż do następnego kroku"
            style={{ float: 'right' }}
          >
            Dalej <Icon type="caret-right" />
          </Button>
        )}
         { current !== 1 && current!==21 && current!==51 && (
          <Button onClick={() => this.prev()}  style={{ marginRight: 10, float: 'right' }} title="Idż do poprzedniego kroku" >
            <Icon type="caret-left" />
            Wstecz
          </Button>
        )}       


       
        
        
        
        
      </div>
    );

    return (
      <Row>
        <Drawer
          title="Wąskie gardła"
          placement="right"
          closable={false}
          width={500}
          onClose={this.onClose}
          visible={this.state.visibleD}
        >
          <Query 
          query={ gql(listFieldsInfos) }
          variables={{ filter: { proceedingId: { eq: proceeding.id}}}}
          fetch-police={'no-cache'}
          >{({loading, data, refetch}) => {
              if(loading) return <Spin indicator={<Icon type="loading" style={{ fontSize: 24 }} spin />}/>
              
              return(
                <FieldsInfoList items={data.listFieldsInfos.items} refetch={refetch}/>
              )
        }}</Query>  
        <div
            style={{
              position: 'absolute',
              left: 0,
              bottom: 0,
              width: '100%',
              borderTop: '1px solid #e9e9e9',
              padding: '10px 16px',
              background: '#fff',
              textAlign: 'right',
            }}
          >
            <Button onClick={this.onClose} style={{ marginRight: 8 }}>
              Zamknij
            </Button>
          </div>
        </Drawer>
        <Col md={5} style={{ padding: "0px 20px", position: 'fixed'  }}>
        { current<20 &&
          <Fragment>
          <h1>Etap pierwszy</h1>
          <Steps
            current={current-1}
            direction="vertical"
            size="small"
            className="proceeding__steps"
          >
            <Step className={ proceeding.step >= 1? 'done': '' } onClick={()=>this.goTo(1)} title="Zamawiajacy" description="Podaj dane zamawiającego" />
            <Step className={ proceeding.step >= 2? 'done': '' } onClick={()=>this.goTo(2)} title="Przedmiot zamówienia" description='Podaj przedmiot zamówienia publicznego' />
            <Step className={ proceeding.step >= 3? 'done': '' } onClick={()=>this.goTo(3)} title="Przygotowanie postępowania"description='Czynności związane z przygotowaniem postępowania'/>
            <Step className={ proceeding.step >= 4? 'done': '' } onClick={()=>this.goTo(4)} title="Osoby cz. A" description="Osoby przygotowujące i przeprowadzające postępowania" />
            <Step className={ proceeding.step >= 5? 'done': '' } onClick={()=>this.goTo(5)} title="Osoby cz. B" description="Osoby wykonujące czynności związane z przygotowaniem postępowania " />
            <Step className={ proceeding.step >= 6? 'done': '' } onClick={()=>this.goTo(6)} title="Osoby cz. C" description="Pozostałe informacje odnośnie osób związanych z postępowaniem" />
            <Step className={ proceeding.step >= 7? 'done': '' } onClick={()=>this.goTo(7)} title="Ogłoszenie" description="Informacje o ogłoszeniach o postępowaniu" />
            <Step className={ proceeding.step >= 8? 'done': '' } onClick={()=>this.goTo(8)} title="SIWZ i wymagania" description="Specyfikacja istotnych warunków zamówienia" />
            <Step className={ proceeding.step >= 9? 'done': '' } onClick={()=>this.goTo(9)} title="Miejsce i termin" description="Miejsce i termin składania ofert" />
          </Steps>
          { current !== 9 &&
          <div style={{ textAlign: 'center'}}><br/><br/>
            <Button style={{ width: 220}} onClick={()=>this.finishPart(1)} > Zakończ etap </Button>
            <br/><br/>
          </div>
          }
          <div style={{ textAlign: 'center'}}>
          <Button style={{ width: 220}} onClick={this.showDrawer}> Wąskie gardła </Button>
          </div>
           </Fragment>
        }
        { current >=20 && current<30 &&
          <Fragment>
          
         
          
          <h1>Etap drugi</h1>
          <Steps
            current={current-21}
            direction="vertical"
            size="small"
            className="proceeding__steps"
          >
            <Step className={ proceeding.step >= 21? 'done': '' } onClick={()=>this.goTo(21)} title="Otwarcie ofert" description="Informacje o otwarciu ofert" />
            <Step className={ proceeding.step >= 22? 'done': '' } onClick={()=>this.goTo(22)} title="Zestawienie ofert" description="Wykaz złożonych ofert do postępowania" />
            <Step className={ proceeding.step >= 23? 'done': '' } onClick={()=>this.goTo(23)} title="Wezwania" description="Wezwania do złożenia niezbędnych danych" />
            <Step className={ proceeding.step >= 24? 'done': '' } onClick={()=>this.goTo(24)} title="Wykluczenia" description="Wyniki badania podstaw wykluczenia" />
            <Step className={ proceeding.step >= 25? 'done': '' } onClick={()=>this.goTo(25)} title="Odrzucenia" description="Oferty odrzucone" />
            <Step className={ proceeding.step >= 26? 'done': '' } onClick={()=>this.goTo(26)} title="Wybór oferty" description="Wybór najkorzystniejszej oferty" />
            <Step className={ proceeding.step >= 27? 'done': '' } onClick={()=>this.goTo(27)} title="Zatwierdzenie wyniku" description="Zatwierdzenie wyniku postępowania" />
            <Step className={ proceeding.step >= 28? 'done': '' } onClick={()=>this.goTo(28)} title="Zawiadomienie" description="Zawiadomienie o wyborze najkorzystniejszej oferty/unieważnieniu postępowania" />
          
          </Steps>
          {/* eslint-disable-next-line */}
          <a href="" style={{"dispaly":"none"}} download ref={el => (this.linkRef = el)} ></a>
          <div style={{ textAlign: 'center'}}>
            
             <Mutation 
              mutation={ gql(reportProceeding) }
              >
              {(ReportProceeding, { data, loading}) => (
              <Fragment>
                 <Button
                  style={{ width: 220, marginTop: 10}}
                  icon="profile"
                  
                  disabled={this.props.toUpdate}
                  onClick={()=>this.showModal(1)}
                >
                  Pobierz protokół z cz.1
                </Button>
                <Modal
                title={ this.state.part === 3? "Protokół końcowy":"Protokół z cz."+this.state.part  }
                visible={this.state.visible}
                onCancel={this.handleCancel}
                footer={[
                  <Button key="back" onClick={this.handleCancel}>Anuluj</Button>,
                  <Button key="submit" type="primary" loading={gen} onClick={(e)=>this.handleOk(e,ReportProceeding)}>
                    {gen ? "Generowanie protkołu..." : "Generuj protokół" }
                  </Button>,
                ]}
              >
                Wybierz format pliku:<br/><br/>
                <RadioGroup onChange={this.onChange} value={this.state.ext}>
                  <Radio style={radioStyle} value="pdf">pdf</Radio>
                  <Radio style={radioStyle} value="epub">epub</Radio>
                  <Radio style={radioStyle} value="mobi">mobi</Radio>
                  <Radio style={radioStyle} value="rtf">rtf</Radio>
                  <Radio style={radioStyle} value="html">html (mobilny)</Radio>
                </RadioGroup>
              </Modal>
              </Fragment>
              )}
              
              </Mutation>
              { current !== 28 &&
                <Button style={{ width: 220, marginTop: 10}} onClick={()=>this.finishPart(2)} > Zakończ etap </Button>
              }
              <br/>
              <Button style={{ width: 220, marginTop: 10}} onClick={this.showDrawer}> Wąskie gardła </Button>
              
             
                        
          </div>
          
          </Fragment>
        }
        { current >=50 && 
          <Fragment>
          <h1>Etap trzeci</h1>
          <Steps
            current={current-51}
            direction="vertical"
            size="small"
            className="proceeding__steps"
          >
            <Step className={ proceeding.step >= 51? 'done': '' } onClick={()=>this.goTo(51)} title="Udzielenie zamówienia" description="Informacje o udzieleniu zamówienia" />
            <Step className={ proceeding.step >= 52? 'done': '' } onClick={()=>this.goTo(52)} title="Ochrona prawna" description="Środki ochrony prawnej" />
            <Step className={ proceeding.step >= 53? 'done': '' } onClick={()=>this.goTo(53)} title="Nowe/powtórzone czynności" description="Czynności nowe/czynności powtórzone w postępowaniu" />
            <Step className={ proceeding.step >= 54? 'done': '' } onClick={()=>this.goTo(54)} title="Zamówienia" description="Informacje o zamówieniu" />
            <Step className={ proceeding.step >= 55? 'done': '' } onClick={()=>this.goTo(55)} title="Protokół" description="Informacje o protokole z postępowania" />
            <Step className={ proceeding.step >= 56? 'done': '' } onClick={()=>this.goTo(56)} title="Załączniki" description="Dokumenty stanowią załączniki do protokołu" />
           
          </Steps>
          <br/><br/><div style={{ textAlign: 'center'}}>
          {/* eslint-disable-next-line */}
          <a href="" style={{"dispaly":"none"}} download ref={el => (this.linkRef = el)} ></a>
          <Mutation 
            mutation={ gql(reportProceeding) }
            >
            {(ReportProceeding, { data, loading}) => (
              <Fragment>
               <Button
                 style={{ width: 220, marginTop: 10}}
                icon="profile"
                disabled={this.props.toUpdate}
                onClick={()=>this.showModal(2)}
              >
                Pobierz protokół z cz.2
              </Button>
              { proceeding.step === 56 &&
              <Button
                 style={{ width: 220, marginTop: 10}}
                icon="profile"
                disabled={this.props.toUpdate}
                onClick={()=>this.showModal(3)}
              >
                Pobierz protokół końcowy
              </Button>
              }
              <Modal
                title={ this.state.part === 3? "Protokół końcowy":"Protokół z cz."+this.state.part  }
                visible={this.state.visible}
                onCancel={this.handleCancel}
                footer={[
                  <Button key="back" onClick={this.handleCancel}>Anuluj</Button>,
                  <Button key="submit" type="primary" loading={gen} onClick={(e)=>this.handleOk(e,ReportProceeding)}>
                    {gen ? "Generowanie protkołu..." : "Generuj protokół" }
                  </Button>,
                ]}
              >
                Wybierz format pliku:<br/><br/>
                <RadioGroup onChange={this.onChange} value={this.state.ext}>
                  <Radio style={radioStyle} value="pdf">pdf</Radio>
                  <Radio style={radioStyle} value="epub">epub</Radio>
                  <Radio style={radioStyle} value="mobi">mobi</Radio>
                  <Radio style={radioStyle} value="rtf">rtf</Radio>
                  <Radio style={radioStyle} value="html">html (mobilny)</Radio>
                </RadioGroup>
              </Modal>
              </Fragment>
            )}
            </Mutation>
            <Mutation 
            mutation={ gql(reportMail) }
            >
            {(ReportMail, { data, loading}) => (
              <Fragment>
               <Button
                 style={{ width: 220, marginTop: 10}}
                icon="profile"
                disabled={this.props.toUpdate}
                onClick={()=>this.reportMail(ReportMail)}
                loading={this.state.genMail}
              >
                {this.state.genMailTxt}
              </Button>
              </Fragment>
            )}
            </Mutation>
          
            <br/><Button style={{ width: 220, marginTop: 10}} onClick={this.showDrawer}> Wąskie gardła </Button>
          </div>
          </Fragment>
        }
        </Col>
        <Col md={19} style={{ background: '#fff', borderLeft:'1px solid #eee',    minHeight: '85vh'}} offset = {5} >
          
            { action_buttons2 }
          
          <div className='formProc' style={{ padding: '12px 0px'}}>
          <Mutation 
                      mutation={ gql(updateProceeding) }
                      update={(cache, data) => {
                    
                            cache.writeQuery({
                                  query: gql(getProceeding),
                                  variables: { id: "" + data.data.updateProceeding.id },
                                  data: { getProceeding: {...data.data.updateProceeding} }
                            });
                            
                            
                            // const ce = cache.readQuery({ query: gql(listProceedings) });
                            // let newData = {...ce}
          
                            // let _items = []
                            // newData.listProceedings.items.map(i=>{
                            //   if(i.id === data.data.updateProceeding.id )
                            //     _items.push(data.data.updateProceeding)
                            //   else _items.push(i)
          
                            //   console.log(_items)
          
                            // })
          
                            // newData.listProceedings.items=_items
                            
                            // cache.writeQuery({
                            //       query: gql(listProceedings),
                            //       data: newData
                            // });
                            
                            
                      }}
                    >
                    
                    {(UpdateProceeding, { data, loading}) => (
                     <Fragment>
                        {Component && <ComponentContainer current={current} Component={Component} proceeding={proceeding} saving={saving} UpdateProceeding={UpdateProceeding} reload={this.reload}/>}
                     </Fragment>
                      )}
          </Mutation>
          </div>
          <div className='form-footer'>
          { action_buttons }
          </div>
          
        </Col>
      </Row>
    );
  }
}

// update={(cache, data) => {
//     const cachedData = cache.readQuery({ query: gql(getProceeding), variables: { id: proceeding.id } });
//     console.log(cachedData, data)
//     // const { items } = listAUC_admin_organizations_users

//     const newData =  {
//         listAUC_admin_organizations_users: { 
//               ...listAUC_admin_organizations_users,
//               items: items.concat([ data.data.createAUC__admin_organization_users ])
//     }}

//     cache.writeQuery({
//           query: ListAucAdminOrganizationsUsers,
//           data: newData
//     });
// }}
// <Button style={{ width: 220, marginTop: 10}}> Unieważnij postępowanie </Button><br/>